"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _bumaga = require("./bumaga.tabs");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _usePropsUpdatedChildren = require("../../helpers/usePropsUpdatedChildren");

var _tabsHeader = require("./tabs-header");

var _tabsHeaderDropdown = require("./tabs-header-dropdown");

var _tabsBody = require("./tabs-body");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "classes", "view"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c88f1b9e6{overflow:hidden}.c395b73c4{border-radius:.9375rem;background:#fff}.c23c44f90{border-radius:0;background:0 0}.cf4ea9b71{border-radius:0;background:0 0}");
var styles = {
  root: 'c88f1b9e6',
  '--view-usual': 'c395b73c4',
  '--view-child': 'c23c44f90',
  '--view-secondary': 'cf4ea9b71'
};

var Tabs = function Tabs(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var elementTypes = [_tabsHeader.TabsHeader, _tabsBody.TabsBody, _tabsHeaderDropdown.TabsHeaderDropdown];

  var updateFunc = function updateFunc(oldProps) {
    return !oldProps ? {
      view: view
    } : _objectSpread(_objectSpread({}, oldProps), {}, {
      view: view
    });
  };

  var updatedChildren = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(children, elementTypes, updateFunc);
  return /*#__PURE__*/_react.default.createElement(_bumaga.Tabs, rest, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, updatedChildren));
};

exports.Tabs = Tabs;
var view = ['usual', 'child', 'secondary'];
Tabs.modes = {
  view: view
};
Tabs.propTypes = {
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  view: (0, _propTypes.oneOf)(view)
};
Tabs.defaultProps = {
  view: 'usual',
  classes: {}
};